module.exports = __webpack_public_path__ + "static/media/11client.9d74b911.png";